<template>
  <section class="po-timeline">
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12 form-group top_search">
        <div id="wizard" class="form_wizard wizard_horizontal purchase-order--timeline">
          <ul class="wizard_steps anchor">
            <li>
              <a
                class="selected purchase-order--steps purchase-order--created"
                data-id="created"
                isdone="1"
                rel="1"
              >
                <span class="step_no">
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </span>
                <span class="step_descr">
                  <span class="status-title">{{ !isZeenow ? 'PO created' : 'Pedido feito' }}</span>
                  <br />
                  <small>
                    <em>
                      <span
                        class="purchase-order--date-created"
                      >{{ item.created | moment('DD/MM/YYYY') }}</span>
                    </em>
                    &nbsp;
                    <el-tooltip placement="top">
                      <div
                        slot="content"
                        style="text-transform: uppercase;"
                      >This is the date that the PO was registered into OMS</div>
                      <i class="el-icon-information"></i>
                    </el-tooltip>
                  </small>
                </span>
              </a>
            </li>
            <li>
              <a
                class="purchase-order--steps purchase-order--production"
                :class="inProductionClasses"
                data-id="production"
                isdone="0"
                rel="2"
              >
                <span class="step_no">
                  <i class="fa fa-industry" aria-hidden="true"></i>
                </span>
                <span class="step_descr">
                  <span
                    class="status-title"
                  >{{ !isZeenow ? 'In Production' : 'Pedido em andamento' }}</span>
                  <br />
                  <small v-if="getPoProductionStart">
                    <em>
                      <span
                        class="purchase-order--date-created"
                      >{{ getPoProductionStart | moment('DD/MM/YYYY') }}</span>
                    </em>
                    &nbsp;
                    <el-tooltip placement="top">
                      <div
                        slot="content"
                        style="text-transform: uppercase;"
                      >This is the estimated start production date of the PO</div>
                      <i class="el-icon-information"></i>
                    </el-tooltip>
                  </small>
                </span>
              </a>
            </li>
            <li>
              <a
                class="purchase-order--steps purchase-order--shipped"
                :class="deliveredClasses"
                data-id="shipped"
                isdone="0"
                rel="3"
              >
                <span class="step_no">
                  <i class="fa fa-truck" aria-hidden="true"></i>
                </span>
                <span class="step_descr">
                  <span class="status-title">{{ !isZeenow ? 'Handed Over' : 'Recebido no Hub' }}</span>
                  <br />
                  <small v-if="getPoShippedDate">
                    <em>
                      <span
                        class="purchase-order--date-created"
                      >{{ getPoShippedDate | moment('DD/MM/YYYY') }}</span>
                    </em>
                    &nbsp;
                    <el-tooltip placement="top">
                      <div
                        slot="content"
                        style="text-transform: uppercase;"
                      >This is the date the PO was delivered</div>
                      <i class="el-icon-information"></i>
                    </el-tooltip>
                  </small>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="flex">
        <button
          v-if="item.status !== 'Shipped' && (checkUserGroup(getGroups.FACTORY) ||
          checkUserGroup(getGroups.MANAGE))"
          type="button"
          class="btn btn-primary col-md-2 btn-update-status"
          @click="openUpdateStatus"
        >
          <i class="fa fa-forward"></i>
          {{ !isZeenow ? 'Update status' : 'Atualizar status'}}
        </button>
        <h3 v-if="item.status == 'Shipped'">
          <em>This PO has been delivered.</em>
        </h3>
        <br />
        <el-dialog title="Change PO Status" :visible.sync="estDateDialogVisible">
          <h4 class="text-center">
            You are updating PO#{{ item.poId }} from
            <br />
            <strong>
              <span class="actual-status">{{ item.status }}</span>
            </strong> to
            <strong>
              <span class="new-status">{{ newStatus }}</span>
            </strong>
          </h4>
          <hr />
          <el-row>
            <h4>Production dates</h4>
          </el-row>
          <el-form :model="estDateForm" :rules="estDateRules" ref="estDateForm">
            <el-row :gutter="10">
              <el-col :span="12">
                <fieldset class="est-date-form">
                  <el-form-item
                    prop="estStartDate"
                    label="Select the estimated start date"
                    required
                  >
                    <el-date-picker
                      v-model="estDateForm.estStartDate"
                      type="date"
                      size="large"
                      format="dd/MM/yyyy"
                      align="center"
                      :editable="isEditable"
                      placeholder="Select the est. start date"
                    ></el-date-picker>
                  </el-form-item>
                </fieldset>
              </el-col>
              <el-col :span="12">
                <fieldset class="est-date-form">
                  <el-form-item prop="estEndDate" label="Select the estimated end date" required>
                    <el-date-picker
                      v-model="estDateForm.estEndDate"
                      type="date"
                      format="dd/MM/yyyy"
                      size="large"
                      align="center"
                      :editable="isEditable"
                      placeholder="Select the est. end date"
                    ></el-date-picker>
                  </el-form-item>
                </fieldset>
              </el-col>
            </el-row>
            <el-form-item label="Add payment info now?" v-if="item.payment.payments.length == 0">
              <el-switch active-text inactive-text v-model="showPaymentsInfoForm"></el-switch>
            </el-form-item>
            <hr />
            <el-row v-if="showPaymentsInfoForm">
              <h4>
                Payment info
                <small>(Can be added later in the payments tab)</small>
              </h4>
            </el-row>
            <el-row :gutter="10" v-if="showPaymentsInfoForm">
              <el-col :span="24">
                <fieldset>
                  <el-form-item prop="proFormaFile" label="Attach the pro forma file">
                    <el-upload
                      class="upload-bl-file"
                      ref="upload"
                      :on-success="onUploadSucces"
                      :on-error="onUploadError"
                      :before-upload="setIsFileUpload"
                      :headers="getHeaders"
                      :action="getUploadProFormaUrl"
                    >
                      <el-button slot="trigger" :plain="true" type="success" size="large">
                        <i class="fa fa-file-o" aria-hidden="true"></i> Select the pro forma File
                      </el-button>
                    </el-upload>
                  </el-form-item>
                </fieldset>
              </el-col>
            </el-row>
            <el-row :gutter="10" v-if="showPaymentsInfoForm">
              <el-col :span="12">
                <fieldset class="est-date-form">
                  <el-form-item prop="paymentDueDate" label="Select the payment due date">
                    <el-date-picker
                      v-model="estDateForm.paymentDueDate"
                      type="date"
                      format="dd/MM/yyyy"
                      size="large"
                      align="center"
                      :editable="isEditable"
                      placeholder="Select the payment due date"
                    ></el-date-picker>
                  </el-form-item>
                </fieldset>
              </el-col>
              <el-col :span="12">
                <fieldset class="est-date-form">
                  <el-form-item prop="paymentDueDate2" label="Select the payment due date 2">
                    <el-date-picker
                      v-model="estDateForm.paymentDueDate2"
                      type="date"
                      format="dd/MM/yyyy"
                      size="large"
                      align="center"
                      :editable="isEditable"
                      placeholder="Select the payment due date 2"
                    ></el-date-picker>
                  </el-form-item>
                </fieldset>
              </el-col>
            </el-row>
            <el-row :gutter="10" v-if="showPaymentsInfoForm">
              <el-col :span="24">
                <fieldset class="est-date-form">
                  <el-form-item prop="paymentObs" label="Add a Payment Observation">
                    <el-input
                      type="textarea"
                      :rows="2"
                      placeholder="Add a payment observation"
                      v-model="estDateForm.paymentObs"
                    ></el-input>
                    <p>
                      <small>
                        <i class="el-icon-information"></i>
                        <em>Write here how this PO should be payed. (Installments, at once)</em>
                      </small>
                    </p>
                  </el-form-item>
                </fieldset>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="estDateDialogVisible = false">Cancel</el-button>
            <el-button type="success" @click="submitUpload('estDateForm')">Confirm</el-button>
          </span>
        </el-dialog>
        <el-dialog title="Change PO status" :visible.sync="shippedDateDialogVisible">
          <p class="text-center">
            Are you sure you want to update the status from
            <br />
            <strong>
              <span class="actual-status">{{ item.status }}</span>
            </strong> to
            <strong>
              <span class="new-status">{{ newStatus }}</span>
            </strong>?
          </p>
          <hr />
          <el-form :model="shippedDateForm" :rules="shippedDateRules" ref="shippedDateForm">
            <fieldset>
              <el-form-item prop="shippedDate" label="Select the delivered date" required>
                <el-date-picker
                  v-model="shippedDateForm.shippedDate"
                  type="date"
                  size="large"
                  format="dd/MM/yyyy"
                  :editable="isEditable"
                  placeholder="Select the delivered date"
                ></el-date-picker>
              </el-form-item>
            </fieldset>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="shippedDateDialogVisible = false">Cancel</el-button>
            <el-button type="success" @click="submitUpload('shippedDateForm')">Confirm</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import apiUrl from "@/services/api_url";
import moment from "moment";
import getFileUploadHeaders from "@/services/http-file-headers";
import * as groups from "@/js/user-groups";

export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      showPaymentsInfoForm: false,
      isEditable: false,
      estDateForm: {
        estStartDate: "",
        estEndDate: "",
        paymentDueDate: "",
        paymentDueDate2: "",
        paymentObs: ""
      },
      shippedDateForm: {
        shippedDate: ""
      },
      estDateRules: {
        estStartDate: [
          {
            type: "date",
            required: true,
            message: "Please pick a start production date",
            trigger: "change"
          }
        ],
        estEndDate: [
          {
            type: "date",
            required: true,
            message: "Please pick a end production date",
            trigger: "change"
          }
        ],
        paymentDueDate: [
          {
            type: "date",
            required: true,
            message: "Please pick a payment due date",
            trigger: "change"
          }
        ],
        paymentObs: [
          {
            required: true,
            message: "Please add an observation",
            trigger: "change"
          }
        ]
      },
      shippedDateRules: {
        shippedDate: [
          {
            type: "date",
            required: true,
            message: "Please pick a delivered date",
            trigger: "change"
          }
        ]
      },
      estDateDialogVisible: false,
      shippedDateDialogVisible: false,
      statusList: ["Created", "In Production", "Delivered"]
    };
  },
  computed: {
    getGroups() {
      return groups;
    },
    inProductionClasses() {
      return {
        selected:
          this.item.status === "In Production" ||
          this.item.status === "Shipped",
        disabled: this.item.status === "Created"
      };
    },
    deliveredClasses() {
      return {
        selected: this.item.status === "Shipped",
        "shipped-highlight": this.item.status === "Shipped",
        disabled:
          this.item.status === "Created" || this.item.status === "In Production"
      };
    },
    newStatus() {
      const actualStatus = this.item.status;
      const indexOfStatus = this.statusList.indexOf(actualStatus) + 1;
      return this.statusList[indexOfStatus];
    },
    ...mapGetters({
      getPoProductionStart: "getPoProductionStart",
      getPoShippedDate: "getPoShippedDate",
      getUser: "getUser",
      isZeenow: "isZeenow"
    }),
    getHeaders() {
      return getFileUploadHeaders();
    },
    getUploadProFormaUrl() {
      return `${apiUrl}pos/${this.item.id}/sendProForma/`;
    }
  },
  methods: {
    checkUserGroup(group) {
      if (process.env.NODE_ENV === "production") {
        for (let i = 0; i < this.getUser.groups.length; i += 1) {
          if (
            this.getUser.groups[i].name.toLowerCase() === group.toLowerCase()
          ) {
            return true;
          }
        }
      }
      return true;
    },
    openUpdateStatus() {
      if (this.item.status === "Created") {
        this.estDateDialogVisible = true;
        return this.estDateDialogVisible;
      } else if (this.item.status === "In Production") {
        this.shippedDateDialogVisible = true;
        return this.shippedDateDialogVisible;
      }
      return false;
    },
    setIsFileUpload() {
      this.isFileUpload = true;
    },
    onUploadSucces() {
      this.$message.success("Success! File uploaded.");
      this.isFileUpload = false;
    },
    onUploadError() {
      this.$message.error("Oops! Something went wrong.");
      this.isFileUpload = false;
    },
    submitUpload(formName) {
      if (this.item.status === "Created") {
        this.$refs[formName].validate(valid => {
          const paymentDue = JSON.stringify(this.estDateForm.paymentDueDate);
          const cleanDate = paymentDue
            .substring(0, paymentDue.indexOf("T"))
            .replace('"', "");
          let paymentDue2;
          let cleanDate2;
          const dateObj = {};
          if (
            this.estDateForm.paymentDueDate2 !== "" &&
            typeof this.estDateForm.paymentDueDate2 !== "undefined"
          ) {
            paymentDue2 = JSON.stringify(this.estDateForm.paymentDueDate2);
            cleanDate2 = paymentDue2
              .substring(0, paymentDue2.indexOf("T"))
              .replace('"', "");
          }
          if (valid) {
            dateObj.startDate = moment(this.estDateForm.estStartDate).format(
              "YYYY-MM-DD"
            );
            dateObj.endDate = moment(this.estDateForm.estEndDate).format(
              "YYYY-MM-DD"
            );
            if (this.estDateForm.paymentDueDate !== "") {
              dateObj.dueDate = cleanDate;
              dateObj.paymentObservation = this.estDateForm.paymentObs;
              if (this.estDateForm.paymentDueDate2 !== "") {
                dateObj.dueDate2 = cleanDate2;
              }
            }
            dateObj.poId = this.item.id;
            this.$store.dispatch("updateStatus", dateObj);
            this.estDateDialogVisible = false;
          }
          return false;
        });
      } else if (this.item.status === "In Production") {
        this.$refs[formName].validate(valid => {
          if (valid) {
            const dateObj = {};
            dateObj.shippedAt = moment(this.shippedDateForm.shippedDate).format(
              "YYYY-MM-DD"
            );
            dateObj.poId = this.item.id;
            this.$store.dispatch("updateStatus", dateObj);
            this.shippedDateDialogVisible = false;
          }
          return false;
        });
      }
    }
  }
};
</script>
<style lang="scss">
.el-upload__input {
  display: none !important;
}
.est-date-form label {
  margin: 10px 0;
}
.el-date-editor.el-input {
  width: 100%;
}
.shipped-highlight .step_no {
  background-color: #1abb9c !important;
}
.po-timeline {
  .el-form-item__label {
    margin: 0;
    padding-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/purchase-orders/purchase-order/partials/PoInternalTimeline.vue